
import { types, actions } from './requests'
export const GETPICTURELIST_TYPES = {
    ...types('GETPICTURELIST'),
}
export const GETPICTURELIST_ACTIONS = {
    ...actions('GETPICTURELIST'),
}